import React from 'react'

import { observer } from 'mobx-react'
import BookkeepingManagerDetailsViewModel from '../BookkeepingManagerDetailsViewModel'
import { BookkeepingManagerAction } from 'admin/bookkeeping/BookkeepingPendingAction'
import Button from 'components/Button'

import styles from './DetailsFooter.sass'

interface DetailsFooterProps {
  vm: BookkeepingManagerDetailsViewModel
}

export default observer(function DetailsFooter({ vm }: DetailsFooterProps) {
  return (
    <div className={styles.footer}>
      <div className={styles.actions}>
        {vm.bookkeepingPendingAction.action ===
          BookkeepingManagerAction.ConfirmAccess && (
          <ConfirmAccessButton vm={vm}></ConfirmAccessButton>
        )}
      </div>
    </div>
  )
})

interface ConfirmAccessButtonProps {
  vm: BookkeepingManagerDetailsViewModel
}

function ConfirmAccessButton({ vm }: ConfirmAccessButtonProps) {
  return (
    <Button
      onClick={vm.confirmAccess}
      type="primary"
      loading={vm.confirmAccess.pending}
      disabled={vm.confirmAccess.pending}
      data-test="bookkeeping-manager-details-confirm-access-button"
    >
      Confirm Access
    </Button>
  )
}
